
<div style="border-radius: 10px !important;">
  <!-- Default Group Configuration -->
  <ng-container *ngIf="context !== 'DeLink'">
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;padding-bottom: 0px;padding-left: 15px;background-color: #F8F8FA ;border-radius: 10px 10px 0px 0px;">
      <div class="col-md-12 col-12 col-xs-12" style="display: flex; justify-content: space-between; padding: 0px;align-items: center; ">
        <div class="col-md-8 col-5 col-sm-8 pad0 inLneBlk newHeader " style="vertical-align: top; padding: 0px;">
          <div class="col-md-12 pad0 d-flex justify-content-between align-items-center" style="display: flex; justify-content: space-between; align-items: center;padding: 0px;">
            <span style="font-size: 20px; font-weight: 500; color: #333333;">
              Default Group for {{context}}
            </span>
          </div>
        </div>
        <span style="padding: 0px 0px !important; top: -6px;" *ngIf="!isFromLink">  
          <i class="closeMdl zmdi zmdi-close Marginbtm" (click)="close()"></i>
        </span>
      </div>
    </div>

    <div class="modal-body" style="width: 100%; padding: 0px 15px 20px 15px; background-color: #FFFFFF;line-height: 15px;">
      <p style="margin: 0; font-size: 14px; color: #666666;">Select the Account Group where your {{showConn}}s' ledgers will be saved.</p>
    </div>
        
    <!--Body-->
    <div class="modal-body" style="padding: 0px;background-color:#F8F8FA;border-radius: 0px 0px 10px 10px; {{isFromLink ? 'height: 100%;' : ''}}">
        <div class="col-md-12 col-12 col-sm-12" style="padding: 0px 15px 15px 15px;">
          <div class="form-group">
            <div class="col-md-12 col-sm-12 col-12 mrgnTp10" style="text-align: left; padding: 0px;">
              <div class="label-new" style="font-size: 12px;">{{context}}</div>
              <select class="form-control fn13 formCtlFltr crntColor" [(ngModel)]="selectedHead" placeholder="Select Executive">
                <option [value]="0">Select Group</option>
                <ng-container *ngFor="let head of heads" >
                  <ng-container *ngIf="head.HeadID == head.LevelPath.split('~')[2]">
                      <option [value]="head.HeadID">
                        {{ head.HeadName }}
                      </option>
                  </ng-container>
                </ng-container>
              </select>
            </div>
          </div>
          <span class="btn-darkGreen brdrRadius3 btn-save" style="padding: 2px 7px 1px; height: 30px; font-size: 14px;" (click)="saveChoice()">
            <i class="fa fa-check" style="margin-right: 5px;"></i>
            Save
          </span>
        </div>
    </div>
  </ng-container>

  <!-- Accounts De-Link Configuration -->
  <ng-container *ngIf="context === 'DeLink'">
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;padding-bottom: 0px;padding-left: 15px;background-color: #F1F1F0 ;border-radius: 10px 10px 0px 0px;">
      <div class="col-md-12 col-12 col-xs-12" style="display: flex; justify-content: space-between; padding: 0px;align-items: center; ">
        <div class="col-md-10 col-5 col-sm-10 pad0 inLneBlk newHeader " style="vertical-align: top; padding: 0px;">
          <span style="font-size: 20px; font-weight: 500; color: #333333;">
            {{agencyData[0]?.AcctDocLinked ? 'De-link Accounts from' : 'Link Accounts with'}} Sales & Purchase
          </span>
        </div>
        <span style="padding: 0px 0px !important; top: -6px;">  
          <i class="closeMdl zmdi zmdi-close Marginbtm" (click)="close()"></i>
        </span>
      </div>
    </div>

    <!--Body-->
    <div class="modal-body" style="padding: 10px 20px 20px 20px; background-color: #F1F1F0;">
      <div class="row">
          <div class="col-md-12">
              <div class="mrgnTp10" style="font-size: 14px;">
                  <p style="color: #666666;">
                    When disabled, you will no longer be required to create vouchers or configure ledgers while creating invoices and other documents.
                  </p>
                  <p style="color: #666666; margin-bottom: 15px;">
                    Your existing accounting data will remain unchanged. This will only affect new documents.
                  </p>
              </div>
              <p style="font-size: 14px; margin-bottom: 0px;">
                  <span>Current Preference:</span> 
                  <span style="margin-left: 5px; font-weight: bold;">
                      {{ agencyData[0]?.AcctDocLinked ? 'Enabled' : 'Disabled' }}
                  </span>
              </p>
          </div>
      </div>
    </div>

    <!--Footer-->
    <div class="modal-footer" style="background-color: #F1F1F0; border-top: none; border-radius: 0px 0px 10px 10px; padding: 0px 15px 15px 15px;
        display: flex; justify-content: left;">
        <button type="button" class="btn-darkGreen brdrRadius3 btn-save" (click)="confirmDeLink(1)" *ngIf="!agencyData[0]?.AcctDocLinked"
            style="font-size: 14px; padding: 1.5px 8px 1.5px;">
          <i class="fa fa-check" style="margin-right: 5px;"></i> Enable
        </button>
        <button type="button" class="btn-darkGreen brdrRadius3 btn-save" (click)="confirmDeLink(0)"  *ngIf="agencyData[0]?.AcctDocLinked"
          style="font-size: 14px; padding: 1.5px 8px 1.5px;">
          <i class="fa fa-check" style="margin-right: 5px;"></i> Disable
        </button>
        <span class="bz-btn btn-close" (click)="close()" style="margin-left: 10px">
            <i class="fa fa-close mr5"></i> Close
        </span>
    </div>
  </ng-container>
</div>